import AppShell from "@/pages/AppShell";
import { LayoutDashboard, BookOpen, Upload, Plus, ListChecks, Users, BarChart3 } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/questions", label: "Question Bank", icon: BookOpen },
  { to: "/admin/import", label: "Import Wizard", icon: Upload },
  { to: "/admin/questions/new", label: "New Question", icon: Plus },
  { to: "/admin/tests", label: "Tests", icon: ListChecks },
  { to: "/admin/students", label: "Users", icon: Users },
  { to: "/admin/analytics", label: "Analytics", icon: BarChart3 },
];

export default function AdminLayout() {
  return <AppShell nav={NAV} brandLabel="Mock Test Club" accent="Admin" />;
}
